import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Select from 'react-select';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import { generateAxiosInstanceCommon } from '../hooks/useAuthorizedReuestCommon';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../components/ModalsCommonFunctions';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../components/Navigation';
import Pagination from '../components/Pagination';

const ExamPattern = () => {
    const authorizedAxios = generateAxiosInstance();
    const authorizedAxiosCommon = generateAxiosInstanceCommon()
    const initialExamPatterState = {
        exam_pattern_name: "",
        perquestion_marks: '',
        pernegetive_question_marks: ''
    }

    const [examPatternList, setExamPatternList] = useState([])
    const [editId, setEditId] = useState(null)
    const [examPatternData, setExamPatternData] = useState(initialExamPatterState)

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);
    const [refresh, setRefresh] = useState(true);

    const [examPatternSort, setExamPatternSort] = useState(null);
    const [positiveQuestionMarkSort, setPositiveQuestionMarkSort] = useState(null);
    const [negativeQuestionMarkSort, setNegativeQuestionMarkSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["exam_pattern_name", "perquestion_marks", "pernegetive_question_marks"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getExamPatternList();
    }, [refresh]);

    const getExamPatternList = async () => {
        try {
            const apiUrl = `/exam-patterns`;
            const response = await authorizedAxiosCommon.get(apiUrl);
            setExamPatternList(response.data.data);
        } catch (error) {
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        }
    }

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            setRefresh(!refresh);
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        setExamPatternList(await searchArray("C", "/exam-patterns", searchKeys, searchValue.trim(), "data"))
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(examPatternList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(examPatternList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > examPatternList.length) {
            endIndex = examPatternList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(examPatternList.slice(startIndex, endIndex));
    }, [examPatternList, currPage, itemsPerPage]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        // Check if the input name is 'perquestion_marks'
        if (name === 'perquestion_marks') {
            // Check if the value is less than or equal to 0
            if (parseFloat(value) <= 0) {
                setError(prevData => ({
                    ...prevData,
                    [name]: 'Value must be greater than 0.',
                }));
                return;
            } else {
                if (error[name]) {
                    setError(prevData => ({
                        ...prevData,
                        [name]: '',
                    }));
                }
            }
        }

        // Check if the value is negative
        if (name === 'pernegetive_question_marks') {
            if (parseFloat(value) < 0) {
                setError(prevData => ({
                    ...prevData,
                    [name]: 'Value cannot be negative.',
                }));
                // Stop further execution
                return;
            }
        }

        setExamPatternData(prevData => ({
            ...prevData,
            [name]: value
        }));
    }

    //error
    const initialErrorState = {

    }

    const [error, setError] = useState(initialErrorState)

    const validateForm = () => {
        return Object.values(error).every((error) => error === '') && Object.values(examPatternData).every((value) => typeof (value) == "string" ? value !== '' : value.length !== 0)
    };

    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(examPatternData)) {
                if (value === '' || value.length == 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }, [examPatternData])

    const addLesson = async () => {
        if (validateForm()) {
            try {
                setLoading(true);
                const apiUrl = `/exam-patterns`;
                const response = await authorizedAxiosCommon.post(apiUrl, examPatternData);
                await getExamPatternList();
                setExamPatternData(initialExamPatterState)

                setSaveId(response.data.examPattern.id);
                setExamPatternSort(null);
                setPositiveQuestionMarkSort(null);
                setNegativeQuestionMarkSort(null);
                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        } else {
            for (const [key, value] of Object.entries(examPatternData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }

    const deleteLesson = async (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            try {
                setLoading(true);
                const apiUrl = `/exam-patterns/${id}`;
                const response = await authorizedAxiosCommon.delete(apiUrl);
                // await getExamPatternList();
                const page = deleteItem(currPage, itemsPerPage, examPatternList.length);
                setRefresh(!refresh);
                setCurrPage(page);
                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        }
    }

    const updateLesson = async () => {
        if (validateForm()) {
            try {
                const apiUrl = `/exam-patterns/${editId}`;
                setLoading(true);
                const response = await authorizedAxiosCommon.put(apiUrl, examPatternData);
                await getExamPatternList();
                setSaveId(response.data.examPattern.id);
                setExamPatternData(initialExamPatterState)
                setEditId(null);
                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        } else {
            for (const [key, value] of Object.entries(examPatternData)) {
                if (value == '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }

    useEffect(() => {
        if (examPatternSort == true || examPatternSort == false) {
            setPositiveQuestionMarkSort(null);
            setNegativeQuestionMarkSort(null);
        }
    }, [examPatternSort])

    useEffect(() => {
        if (positiveQuestionMarkSort == true || positiveQuestionMarkSort == false) {
            setExamPatternSort(null);
            setNegativeQuestionMarkSort(null);
        }
    }, [positiveQuestionMarkSort])

    useEffect(() => {
        if (negativeQuestionMarkSort == true || negativeQuestionMarkSort == false) {
            setExamPatternSort(null);
            setPositiveQuestionMarkSort(null);
        }
    }, [negativeQuestionMarkSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <div id='scroll-up'></div>
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Exam Pattern</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fas fa-table"></i> Exam Pattern</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="exam_pattern_name" className="col-form-label"><span style={{ color: "red" }}>*</span>Pattern Name :</label>
                                                    <input type="text" className="form-control" id={`exam_pattern_name`} name='exam_pattern_name' value={examPatternData.exam_pattern_name} onChange={(e) => handleInputChange(e)} />
                                                    {error.exam_pattern_name && <p style={{ color: 'red' }}>{error.exam_pattern_name}</p>}

                                                </div>
                                                <div className="col-md-6">
                                                    <label for="perquestion_marks" className="col-form-label"><span style={{ color: "red" }}>*</span>Per Question Mark :</label>
                                                    <input type="number" className="form-control" id={`perquestion_marks`} name='perquestion_marks' onChange={(e) => handleInputChange(e)} value={examPatternData.perquestion_marks} />
                                                    {error.perquestion_marks && <p style={{ color: 'red' }}>{error.perquestion_marks}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="pernegetive_question_marks" className="col-form-label"><span style={{ color: "red" }}>*</span>Per Negative Question Mark :</label>
                                                    <input type="number" className="form-control" id={`pernegetive_question_marks`} name='pernegetive_question_marks' onChange={(e) => handleInputChange(e)} value={examPatternData.pernegetive_question_marks} />
                                                    {error.pernegetive_question_marks && <p style={{ color: 'red' }}>{error.pernegetive_question_marks}</p>}
                                                </div>

                                            </div>
                                            <div className="row">
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        {!editId && <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={addLesson}>Save</button>}
                                                        <button className="btn btn-outline-danger delete_icon" type="button" style={{ marginRight: '20px' }} onClick={() => { setExamPatternList([]); setEditId(''); setExamPatternData(initialExamPatterState); setError(initialErrorState) }}>Reset</button>
                                                        {editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateLesson} disabled={!editId}>Update</button>)}
                                                    </div>
                                                </div>
                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">
                                                                            Exam Pattern
                                                                            <SortIcon sortState={examPatternSort} setSortState={setExamPatternSort} setData={setExamPatternList} setCurrPage={setCurrPage} sortingPath={"exam_pattern_name"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Per Question Mark
                                                                            <SortIcon sortState={positiveQuestionMarkSort} setSortState={setPositiveQuestionMarkSort} setData={setExamPatternList} setCurrPage={setCurrPage} sortingPath={"perquestion_marks"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Per Negative Question Mark
                                                                            <SortIcon sortState={negativeQuestionMarkSort} setSortState={setNegativeQuestionMarkSort} setData={setExamPatternList} setCurrPage={setCurrPage} sortingPath={"pernegetive_question_marks"} />
                                                                        </th>
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData.length > 0 ?
                                                                            displayedData.map((lesson, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{lesson.exam_pattern_name}</td>
                                                                                        <td>{lesson.perquestion_marks}</td>
                                                                                        <td>{lesson.pernegetive_question_marks}</td>
                                                                                        <td>
                                                                                            <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => {
                                                                                                setExamPatternData({
                                                                                                    exam_pattern_name: lesson.exam_pattern_name,
                                                                                                    perquestion_marks: lesson.perquestion_marks,
                                                                                                    pernegetive_question_marks: lesson.pernegetive_question_marks
                                                                                                });
                                                                                                setEditId(lesson.id);
                                                                                                document.getElementById('scroll-up').scrollIntoView({ behavior: 'smooth' });
                                                                                            }}><i class="fa-light fa-pen-to-square"></i></button>
                                                                                            <button className="btn btn-outline-danger delete_icon" type="button" disabled={editId === lesson.id} onClick={() => deleteLesson(lesson.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Exam Pattern Available</th>

                                                                            </tr>)
                                                                    }

                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={examPatternList.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default ExamPattern;